/* eslint-disable @typescript-eslint/no-explicit-any */

import { serialize, SerializeOptions } from 'cookie'
import { isUndefined } from 'lodash-es'

export type Cookies =
  | { [key: string]: string }
  | Partial<{ [key: string]: string }>

export type CookieValue = string | undefined

const stringify = (value: any): any => {
  try {
    if (typeof value === 'string') {
      return value
    }
    const stringifiedValue = JSON.stringify(value)

    return stringifiedValue
  } catch (error) {
    return value
  }
}

const decode = (str: string): string => {
  if (!str) return str

  return str.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
}

const getCookies = (): Cookies | undefined => {
  const cookies: Cookies = {}
  const documentCookies = document.cookie ? document.cookie.split('; ') : []

  documentCookies.forEach(documentCookie => {
    const [name, ...value] = documentCookie.split('=')
    const cookie = value.join('=')
    cookies[name] = decode(cookie)
  })

  return cookies
}

export const getCookie = (key: string): CookieValue => {
  const _cookies = getCookies()
  const value = _cookies?.[key]

  if (isUndefined(value)) return undefined

  return value
}

export const setCookie = (
  key: string,
  data: any,
  options: SerializeOptions = {},
): void => {
  const cookieStr = serialize(key, stringify(data), {
    path: '/',
    ...options,
  })

  document.cookie = cookieStr
}

export const deleteCookie = (
  key: string,
  options: SerializeOptions = {},
): void => {
  setCookie(key, '', { ...options, maxAge: -1 })
}
